
import {
  Vue,
  Component,
  Model,
  Watch,
  Prop,
  Emit,
} from 'vue-property-decorator';
import lazyInject from '@/di';
import VehicleService from '@/services/vehicle.service';

@Component
export default class CTypeField extends Vue {
  val: any = '';

  @lazyInject(VehicleService)
  private vehicleService!: VehicleService;

  useTofieldOptions = [];

  @Prop()
  readonly!: boolean;

  @Prop()
  placeholder!: string;

  getLabel(arr: any, val: any) {
    const category = arr.find((item: any) => item.id === +val);
    // console.log(category, 'category');
    if (category) {
      const tag = category.tags;
      // console.log(tag, 'tag');
      this.$emit('upTagAudit', tag, false);
    }
    return category ? category.category : '';
  }

  @Prop()
  disabled!: boolean;

  @Prop()
  labelId!: string;

  @Watch('val')
  changeVal() {
    this.$emit('change', this.val);
  }

  @Emit('update')
  updateVal() {
    return this.val;
  }

  @Model('change')
  value!: any;

  // changeColor(val: string) {
  //   this.val = val;
  // }

  isType = false;

  @Watch('value')
  watchValue() {
    if (this.value) {
      this.val = Number(this.value);
      if (this.isType) {
        this.upChange(Number(this.value), false);
        this.isType = false;
      }
    } else {
      this.val = undefined;
    }
  }

  changeTag(val: any) {
    // console.log(val, 'val');
    this.upChange(val, true);
  }
  upChange(val: any, isEmit = true) {
    const tag: any = this.useTofieldOptions.find(
      (item: any) => item.id === val,
    );
    // console.log(tag, 'tag');
    this.$emit('upTag', tag.tags, isEmit);
  }

  async mounted() {
    const res = await this.vehicleService.getCommodityCategory({
      label_id: this.labelId,
    });
    this.useTofieldOptions = res;
    this.isType = true;

    this.watchValue();
  }
}
